module.exports = __webpack_public_path__ + "img/113009.760d1aa7.png";